import { ProfessionalRoute } from '/@/modules/professional/routes/professional.routes';
import { MyTeamRouteConfig } from '/@/modules/professional/routes/MyTeamRouteConfig';

export const router = [
  MyTeamRouteConfig.factory({
    path: `/${ProfessionalRoute.MYTEAM.path}`,
    name: ProfessionalRoute.MYTEAM.name,
    component: () => import('/@/modules/professional/pages/ProfessionalTeamPage.vue')
  }).build()
];
